import Vue, { PropType } from 'vue'

export default Vue.extend({
  props: {
    questions: Array as PropType<Array<{ question: string; answer: string }>>,
  },
})
